import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShellComponent } from './shell/shell.component';
import { HeaderComponent } from './shell/header/header.component';
import { RouteReusableStrategy } from './route-reusable-strategy';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { I18nService } from './i18n.service';
import { HttpCacheService } from './http/http-cache.service';
import { ApiPrefixInterceptor } from './http/api-prefix.interceptor';
import { ErrorHandlerInterceptor } from './http/error-handler.interceptor';
import { CacheInterceptor } from './http/cache.interceptor';
import { FooterComponent } from './shell/footer/footer.component';
import { MapComponent } from '@app/map/map.component';
import { MenuModule } from 'primeng/menu';
import { SpSidenavComponent } from '@app/sideNav/sp-sidenav.component';
import { JwtModule } from '@auth0/angular-jwt';
import { QdsButton, QdsListItem, QdsNavListItem, QdsTitle } from '@quartzds/core-angular';
NgbModule
export function tokenGetter() {
  return sessionStorage.getItem("token");
}


@NgModule({
  exports: [
    MapComponent,
  ],
  declarations: [
   
    MapComponent,
    
  ],
  imports: [CommonModule, QdsButton, QdsTitle, QdsListItem, QdsNavListItem,
    TranslateModule,
    NgbModule,
    RouterModule,
    MenuModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      },
    })],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    I18nService,
    HttpCacheService,
    ApiPrefixInterceptor,
    ErrorHandlerInterceptor,
    CacheInterceptor,
    {
      provide: HttpClient
      //useClass: HttpService
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }

}
